<template>
  <iColumn gap="small">
    <iText v-if="label" variant="subtle" font-size="small">
      {{ label }}
    </iText>
    <iImageContainer
      v-if="previewUrl"
      :src="previewUrl"
      :alt="label || 'Selected media'"
      :width="240"
      :height="160"
      crop-if-needed
    />
    <iRow gap="small" wrap="nowrap">
      <iButton variant="secondary" @click="openPicker">
        {{ previewUrl ? "Replace" : "Choose" }}
      </iButton>
      <iButton v-if="previewUrl" variant="subtle" @click="clear">
        Remove
      </iButton>
    </iRow>
    <MediaPickerModal
      :visible="pickerVisible"
      :media-type="mediaType"
      :title="pickerTitle"
      @select="onSelect"
      @close="pickerVisible = false"
    />
  </iColumn>
</template>

<script>
import MediaPickerModal from "%/components/MediaPickerModal.vue";
import { useMediaPlaybackStore } from "%/stores/media-playback-store";
import { mediaIdFromValue } from "%/lib/media-reference";

// Reusable media field: v-model holds a media_id (or a legacy URL string for
// not-yet-migrated data). Opens MediaPickerModal to choose/upload/Unsplash,
// emits the chosen media_id, and renders a resolved preview either way.
export default {
  name: "MediaPickerField",
  components: {
    MediaPickerModal,
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: "",
    },
    mediaType: {
      type: String,
      default: "image",
    },
    label: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue"],
  setup() {
    return {
      playbackStore: useMediaPlaybackStore(),
    };
  },
  data() {
    return {
      previewUrl: "",
      pickerVisible: false,
    };
  },
  computed: {
    pickerTitle() {
      return this.label ? `Select ${this.label}` : "Select media";
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler() {
        this.resolvePreview();
      },
    },
  },
  methods: {
    resolvePreview() {
      const mediaId = mediaIdFromValue(this.modelValue);
      if (mediaId === null) {
        this.previewUrl = typeof this.modelValue === "string" ? this.modelValue : "";
        return;
      }
      this.playbackStore.resolveMediaPlayback(mediaId, data => {
        this.previewUrl = data.url;
      }, () => {
        this.previewUrl = "";
      });
    },
    openPicker() {
      this.pickerVisible = true;
    },
    onSelect(media) {
      this.pickerVisible = false;
      this.$emit("update:modelValue", media.media_id);
      if (media.thumbnail_url) {
        this.previewUrl = media.thumbnail_url;
        return;
      }
      this.playbackStore.resolveMediaPlayback(media.media_id, data => {
        this.previewUrl = data.url;
      });
    },
    clear() {
      this.$emit("update:modelValue", "");
      this.previewUrl = "";
    },
  },
};
</script>
